import { useRef, useState } from "react";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { useCommerce } from "../CommerceContext";
import { Field, SaveButton } from "../FormElements";
import { api, errorText } from "../../lib/api";
import { AttachmentPicker } from "./AttachmentPicker";

export const QuoteDialog = () => {
  const {quoteOpen, setQuoteOpen, cart} = useCommerce();
  const [attachments, setAttachments] = useState([]), [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false), [error, setError] = useState(""), [progress, setProgress] = useState(0);
  const requestId = useRef(crypto.randomUUID()), inFlight = useRef(false);

  const changeOpen = open => {
    if (inFlight.current) return;
    setQuoteOpen(open);
    if (!open) {
      setResult(null);setAttachments([]);setError("");setProgress(0);
      requestId.current = crypto.randomUUID();
    }
  };
  const submit = async event => {
    event.preventDefault();
    if (inFlight.current) return;
    inFlight.current = true;
    setBusy(true);setError("");setProgress(0);
    const payload = {...Object.fromEntries(new FormData(event.currentTarget)), items: cart, request_id: requestId.current};
    try {
      let response;
      if (attachments.length) {
        const body = new FormData();
        body.append("payload", JSON.stringify(payload));
        attachments.forEach(({file}) => body.append("files", file));
        response = await api.post("/quotes/with-attachments", body, {
          timeout: 300000,
          onUploadProgress: event => {if (event.total) setProgress(Math.round(event.loaded * 100 / event.total));},
        });
      } else {
        response = await api.post("/quotes", payload);
      }
      setResult(response.data);setAttachments([]);
    } catch (failure) {
      setError(errorText(failure));
    } finally {
      inFlight.current = false;setBusy(false);
    }
  };
  return <Dialog open={quoteOpen} onOpenChange={changeOpen}><DialogContent data-testid="quote-modal" className="shop-dialog" hideClose={busy}>
    <DialogTitle>Ajukan penawaran proyek</DialogTitle><DialogDescription>Tim sales MASES Bangunan</DialogDescription>
    {result ? <div className="quote-submit-success" data-testid="quote-success"><CheckCircle2 size={28} aria-hidden="true"/><p>Permintaan <strong data-testid="quote-success-id">{result.quote_id}</strong> tersimpan. Tim sales akan menghubungi Anda.</p>{result.attachments?.length > 0 && <p data-testid="quote-success-attachments">{result.attachments.length} lampiran berhasil disertakan.</p>}<button className="primary" data-testid="quote-success-close" onClick={() => changeOpen(false)}>Selesai</button></div> : <form className="form" onSubmit={submit}>
      <fieldset className="quote-form-fields" disabled={busy}>
        <Field label="Nama lengkap" id="quote-name-input" name="name" required minLength={2} maxLength={120}/>
        <Field label="Nomor WhatsApp" id="quote-phone-input" name="phone" required minLength={8} maxLength={25}/>
        <Field label="Perusahaan (opsional)" id="quote-company-input" name="company" maxLength={200}/>
        <Field label="Nama proyek" id="quote-project-input" name="project" required minLength={2} maxLength={200}/>
        <Field label="Lokasi proyek" id="quote-location-input" name="location" required minLength={2} maxLength={500}/>
        <Field label="Kebutuhan material" id="quote-notes-input"><textarea id="quote-notes-input" data-testid="quote-notes-input" name="notes" maxLength={2000}/></Field>
        <AttachmentPicker attachments={attachments} onChange={setAttachments} disabled={busy}/>
      </fieldset>
      <p className="muted" data-testid="quote-item-count">{cart.length} jenis material dari keranjang</p>
      {busy && attachments.length > 0 && <div className="attachment-progress" data-testid="quote-upload-progress" role="status" aria-live="polite"><progress max="100" value={progress} aria-label="Proses unggah lampiran" data-testid="quote-upload-progress-bar"/><span data-testid="quote-upload-progress-label">{progress < 100 ? `Mengunggah lampiran… ${progress}%` : "Menyimpan lampiran dan penawaran…"}</span></div>}
      {error && <p className="form-error" data-testid="quote-error" role="alert">{error}</p>}
      <SaveButton busy={busy} id="quote-submit-button">Kirim permintaan <ArrowRight size={17}/></SaveButton>
    </form>}
  </DialogContent></Dialog>;
};